export default __webpack_public_path__ + "static/media/Alert.a163e713.svg";